/*
 * inspectionSelections.vue の通常点検、おすすめ整備、route 別初期化、
 * WorkAndBuhin 境界、保存キュー、表示判定を切り出した処理。
 */
export interface InspectionSelectionsInspectTypes {
  GENSHA: number;
  LEGAL56: number;
  JIZEN: number;
}

export interface InspectionSelectionsMd3RouteFlags {
  isGensha: boolean;
  isLegal56: boolean;
  isJizen: boolean;
}

export interface InspectionSelectionsInspectValueSaveState {
  listVal: any[];
  shouldSave: boolean;
}

export interface InspectionSelectionsInspectResultSaveState {
  shouldSave: boolean;
  inspectResult: any;
}

export interface InspectionSelectionsWorkOpenState {
  itemState: any;
  activeInspect: any;
  activeSubCateIndex: number;
}

export interface InspectionSelectionsCloseState {
  shouldSave: boolean;
  isSocket: boolean;
  activeInspect: any;
}

export interface InspectionSelectionsConfirmBuhinState {
  listInspect: any[];
  shouldAutoSetJizenRecommend: boolean;
  shouldAutoSetDuplicateSeibi: boolean;
}

export interface InspectionSelectionsOsusumeWorkToggleState {
  itemState: any;
  activeInspect: any;
}

export interface InspectionSelectionsOsusumeConfirmState {
  itemState: any;
  item: any;
  shouldChangeStatus: boolean;
  shouldSave: boolean;
}

export interface InspectionSelectionsOsusumeCloseState {
  shouldSave: boolean;
  isSocket: boolean;
  activeInspect: any;
  itemState: any;
}

export interface InspectionSelectionsSaveQueueItem {
  item: any;
  status: number;
}

export interface InspectionSelectionsBeforeDestroySaveState {
  shouldFlushTempListSave: boolean;
  shouldClearTimerSave: boolean;
  shouldFlushTempWaitSave: boolean;
  shouldClearTimerSaving: boolean;
}

export interface InspectionSelectionsRecommendResponseItemsState {
  items: any[];
  sumStatus: number;
  nItem: number;
  maxRowNum: number;
}

export interface InspectionSelectionsSavedRecommendCategoryStatus {
  sumStatus: number;
  nItem: number;
  cate: any;
}

export interface InspectionSelectionsSavedRecommendCategoriesState {
  recommendCategories: any[];
  categoryStatuses: InspectionSelectionsSavedRecommendCategoryStatus[];
  maxRowNum: number;
}

export interface InspectionSelectionsSavedRecommendApplyState {
  shouldUpdate: boolean;
  subItems: any[];
}

export interface InspectionSelectionsOsusumeCurrentSaveState {
  shouldSave: boolean;
  items: any[];
}

export interface InspectionSelectionsManualRecommendItemInput {
  uketsukeExtendsId: any;
  seibiNm: string;
  kouchinZn: any;
  kouchinZk: any;
  recommendCategoryId: any;
  inspectCategoryId: any;
  doneStatus: number;
  recommendManualType: number;
}

export interface InspectionSelectionsOsusumeCurrentDataState {
  shouldUpdate: boolean;
  kingakuFlg: boolean;
  loadData: boolean;
  currentData: any[];
}

export interface InspectionSelectionsCurrentDataState {
  shouldUpdate: boolean;
  isOsusume: boolean;
  loadData: boolean;
  currentData: any[];
  activeCategoryData: any;
}

export interface InspectionSelectionsCategoryChangeState {
  shouldChange: boolean;
  activeCategory: number;
  activeSubCategory: number;
  currentData: any[];
  routeInfo: any;
}

export interface InspectionSelectionsSubCategoryChangeState {
  shouldChange: boolean;
  activeSubCategory: number;
  currentData: any[];
  routeInfo: any;
}

export interface InspectionSelectionsOsusumeShowChangeState {
  shouldShowDuplicateError: boolean;
  shouldConfirm: boolean;
  shouldSave: boolean;
  itemState: any;
  activeInspect: any;
}

export interface InspectionSelectionsConfirmHideOsusumeState {
  arrStatusValue: number;
  activeInspect: any;
  itemState: any;
  shouldDeleteBuhin: boolean;
}

export interface InspectionSelectionsPendingInspectSaveState {
  shouldCallPendingSave: boolean;
  pendingItems: any;
  isCallSaveWhenSaving: boolean;
  tempWaitSave: any;
}

export interface InspectionSelectionsTempListSavingState {
  shouldReturn: boolean;
  shouldClearTempListSaving: boolean;
}

export interface InspectionSelectionsInspectSaveErrorState {
  notifyNames: any[];
  tempListSaving: any[];
  shouldClearCurrentData: boolean;
  shouldInitPage: boolean;
}

export interface InspectionSelectionsMultipleInspectSaveErrorState {
  message: any;
  tempListSave: any[];
  arrStatus: any[];
  shouldInitPage: boolean;
}

export interface InspectionSelectionsCategoryStatusInput {
  nItem: number;
  sumStatus: number;
}

export interface InspectionSelectionsNormalCategoryStatusState {
  subItems: any[];
  nItem: number;
  sumStatus: number;
}

export interface InspectionSelectionsRecommendCategoryStatusState {
  subItems: any[];
  nItem: number;
  sumStatus: number;
}

/*
 * inspectionSelections.vue の通常点検保存処理から分離し、
 * 保存前に表示用 field を削除する契約を固定するため。
 */
export function removeInspectionSelectionsInspectViewParams(item: any): any {
  const saveItem = item || {};
  delete saveItem.status;
  delete saveItem.showWork;
  delete saveItem.showValue;
  delete saveItem.isSaving;
  return saveItem;
}

/*
 * 通常点検の保存キュー検索を inspectionSelections.vue から分離し、
 * sknInspectDescriptionId で同一点検を探す契約を固定するため。
 */
export function findInspectionSelectionsInspectSaveIndex(
  list: any,
  sknInspectDescriptionId: any
): number {
  const items = Array.isArray(list) ? list : [];
  return items.findIndex(
    (inspect: any) =>
      inspect.sknInspectDescriptionId == sknInspectDescriptionId
  );
}

/*
 * 通常点検 subItem 内の点検検索を inspectionSelections.vue から分離し、
 * inspectDescriptions 配列から対象点検 index を探す契約を固定するため。
 */
export function findInspectionSelectionsInspectDescriptionIndex(
  subItem: any,
  sknInspectDescriptionId: any
): number {
  const inspectDescriptions =
    subItem && Array.isArray(subItem.inspectDescriptions)
      ? subItem.inspectDescriptions
      : [];
  return findInspectionSelectionsInspectSaveIndex(
    inspectDescriptions,
    sknInspectDescriptionId
  );
}

/*
 * 通常点検の保存キュー更新を inspectionSelections.vue から分離し、
 * 同一点検を置き換えて末尾に積む契約を固定するため。
 */
export function upsertInspectionSelectionsInspectSaveQueue(
  list: any,
  saveItem: any
): any[] {
  const items = Array.isArray(list) ? list.slice() : [];
  const index = findInspectionSelectionsInspectSaveIndex(
    items,
    saveItem && saveItem.sknInspectDescriptionId
  );
  if (index > -1) {
    items.splice(index, 1);
  }
  items.push(saveItem);
  return items;
}

/*
 * 通常点検の保存 payload 生成を inspectionSelections.vue から分離し、
 * apiPath ごとの inspectDescriptions 送信形を固定するため。
 */
export function buildInspectionSelectionsInspectSavePayload(
  apiPath: string,
  inspectDescriptions: any
): any {
  const data: any = {};
  data[apiPath] = [
    {
      subItems: [
        {
          inspectDescriptions: Array.isArray(inspectDescriptions)
            ? inspectDescriptions
            : []
        }
      ]
    }
  ];
  return data;
}

/*
 * おすすめ整備の保存キュー item 生成を inspectionSelections.vue から分離し、
 * status 抽出、表示用 field 削除、カテゴリ ID 付与を固定するため。
 */
export function buildInspectionSelectionsOsusumeSaveQueueItem(params: {
  inspectItem: any;
  categoryId?: any;
}): InspectionSelectionsSaveQueueItem {
  const item = params.inspectItem
    ? JSON.parse(JSON.stringify(params.inspectItem))
    : {};
  const status = item.status || 0;
  delete item.status;
  delete item.showWork;
  delete item.isSaving;
  // jizen の項目側カテゴリIDと画面側サブカテゴリIDを混同しない。
  if (item.sknRecommendInspectCategoryId == null && params.categoryId != null) {
    item.sknRecommendInspectCategoryId = params.categoryId;
  }
  return {
    item,
    status
  };
}

/*
 * おすすめ整備の保存キュー検索を inspectionSelections.vue から分離し、
 * sknRecommendInspecSeibiId または osusumeId で同一整備を探す契約を固定するため。
 */
export function findInspectionSelectionsOsusumeSaveIndex(
  list: any,
  seibiSave: any
): number {
  const items = Array.isArray(list) ? list : [];
  const saveItem = seibiSave || {};
  return items.findIndex(
    (seibi: any) =>
      (seibi.sknRecommendInspecSeibiId &&
        seibi.sknRecommendInspecSeibiId ==
          saveItem.sknRecommendInspecSeibiId) ||
      (seibi.osusumeId && seibi.osusumeId == saveItem.osusumeId)
  );
}

/*
 * おすすめ整備の保存キュー更新を inspectionSelections.vue から分離し、
 * 同一おすすめ整備は置換し、未登録なら追加する契約を固定するため。
 */
export function upsertInspectionSelectionsOsusumeSaveQueue(
  list: any,
  saveItem: any
): any[] {
  const items = Array.isArray(list) ? list.slice() : [];
  const index = findInspectionSelectionsOsusumeSaveIndex(items, saveItem);
  if (index > -1) {
    items[index] = saveItem;
  } else {
    items.push(saveItem);
  }
  return items;
}

/*
 * jizen route のおすすめカテゴリ ID 解決を inspectionSelections.vue から分離し、
 * data.jizen 配下の activeCategory/activeSubCategory から ID を取り出す契約を固定するため。
 */
export function resolveInspectionSelectionsJizenRecommendCategoryId(params: {
  data: any;
  activeCategory: number;
  activeSubCategory: number;
  fallback?: any;
}): any {
  const data = params.data || {};
  const category =
    data.jizen &&
    data.jizen[params.activeCategory] &&
    data.jizen[params.activeCategory].recommend &&
    data.jizen[params.activeCategory].recommend[params.activeSubCategory];
  if (category && category.sknRecommendInspectCategoryId != null) {
    return category.sknRecommendInspectCategoryId;
  }
  return params.fallback != null ? params.fallback : null;
}

/*
 * おすすめカテゴリ ID 解決を inspectionSelections.vue から分離し、
 * data.recommend の activeCategory または fallback を使う契約を固定するため。
 */
export function resolveInspectionSelectionsRecommendCategoryId(params: {
  data: any;
  activeCategory: number;
  fallback?: any;
}): any {
  const data = params.data || {};
  const category =
    data.recommend && data.recommend[params.activeCategory]
      ? data.recommend[params.activeCategory]
      : null;
  if (category && category.sknRecommendInspectCategoryId != null) {
    return category.sknRecommendInspectCategoryId;
  }
  return params.fallback != null ? params.fallback : null;
}

/*
 * おすすめ通常部品の保存用 list 生成を inspectionSelections.vue から分離し、
 * 保存 payload に必要な部品 field と master 金額 fallback を固定するため。
 */
export function buildInspectionSelectionsOsusumeBuhinSaveList(
  buhinList: any
): any[] {
  if (!Array.isArray(buhinList) || buhinList.length === 0) {
    return [];
  }
  return buhinList.map((subElement: any) => ({
    buhinCd: subElement.buhinCd,
    buhinId: subElement.buhinId,
    buhinNm: subElement.buhinNm,
    buhinPriceZk: subElement.buhinPriceZk,
    buhinPriceZn: subElement.buhinPriceZn,
    buhinShubetsuId: subElement.buhinShubetsuId,
    isDelete: subElement.isDelete,
    isExtreme: subElement.isExtreme,
    kingakuZk: subElement.kingakuZk,
    kingakuZn: subElement.kingakuZn,
    quantity: subElement.quantity,
    quantityStep: subElement.quantityStep,
    id: subElement.id ? subElement.id : null,
    buhinMasterZk: subElement.buhinMasterZk
      ? subElement.buhinMasterZk
      : null,
    buhinMasterZn: subElement.buhinMasterZn
      ? subElement.buhinMasterZn
      : null
  }));
}

/*
 * おすすめ部品の保存用 list 生成を inspectionSelections.vue から分離し、
 * osusumeBuhinList の保存 field と master 金額 fallback を固定するため。
 */
export function buildInspectionSelectionsOsusumeRecommendBuhinSaveList(
  osusumeBuhinList: any
): any[] {
  if (!Array.isArray(osusumeBuhinList) || osusumeBuhinList.length === 0) {
    return [];
  }
  return osusumeBuhinList.map((subElement: any) => ({
    buhinCd: subElement.buhinCd,
    buhinId: subElement.buhinId,
    buhinLinkId: subElement.buhinLinkId,
    buhinNm: subElement.buhinNm,
    buhinOsusumeId: subElement.buhinOsusumeId,
    buhinPriceZk: subElement.buhinPriceZk,
    buhinPriceZn: subElement.buhinPriceZn,
    buhinShubetsuId: subElement.buhinShubetsuId,
    id: subElement.id,
    isDelete: subElement.isDelete,
    isExtreme: subElement.isExtreme,
    kingakuExtensionId: subElement.kingakuExtensionId,
    kingakuZk: subElement.kingakuZk,
    kingakuZn: subElement.kingakuZn,
    koukanMeyasuTime: subElement.koukanMeyasuTime,
    kousuu: subElement.kousuu,
    quantity: subElement.quantity,
    quantityStep: subElement.quantityStep,
    buhinMasterZk: subElement.buhinMasterZk
      ? subElement.buhinMasterZk
      : null,
    buhinMasterZn: subElement.buhinMasterZn
      ? subElement.buhinMasterZn
      : null
  }));
}

/*
 * おすすめ通常 item の保存形生成を inspectionSelections.vue から分離し、
 * 部品 list、整備情報、カテゴリ情報の詰め方を固定するため。
 */
export function buildInspectionSelectionsOsusumeSubItemSave(params: {
  element: any;
  buhinList: any[];
  osusumeBuhinList: any[];
}): any {
  const element = params.element;
  return {
    branchId: element.branchId,
    buhinBunruiList: element.buhinBunruiList ? element.buhinBunruiList : [],
    buhinList: params.buhinList,
    buhinSelected: element.buhinSelected,
    inspectResult: element.inspectResult,
    inspectValue: element.inspectValue,
    isDoTenken: element.isDoTenken,
    isInspectDuplicate: element.isInspectDuplicate,
    isNumber: element.isNumber,
    kouchinZn: element.kouchinZn,
    koukanMeyasuTime: element.koukanMeyasuTime,
    manualBuhinList: element.manualBuhinList ? element.manualBuhinList : [],
    osusumeBuhinList: params.osusumeBuhinList,
    osusumeId: element.osusumeId ? element.osusumeId : null,
    osusumeIsShow: element.osusumeIsShow,
    seibiId: element.seibiId,
    sknInspectSeibiDetailId: element.sknInspectSeibiDetailId,
    sknInspectType: element.sknInspectType,
    sknRecommendInspecSeibiId: element.sknRecommendInspecSeibiId,
    sknRecommendInspecSeibiNm: element.sknRecommendInspecSeibiNm,
    sknRecommendInspectCategoryId: element.sknRecommendInspectCategoryId,
    sknRecommendInspectSubCategoryId:
      element.sknRecommendInspectSubCategoryId,
    sknUketsukeExtendsId: element.sknUketsukeExtendsId,
    inspectQuantity: element.inspectQuantity ? element.inspectQuantity : null,
    kousuu: element.kousuu ? element.kousuu : null,
    buhinShubetsuCd: element.buhinShubetsuCd
      ? element.buhinShubetsuCd
      : null,
    kouchinZk: element.kouchinZk ? element.kouchinZk : null,
    isExtreme: element.isExtreme,
    workCd: element.workCd
  };
}

/*
 * おすすめ手入力 item の保存形生成を inspectionSelections.vue から分離し、
 * uketsukeExtendsId、カテゴリ ID、部品 list、金額 field の詰め方を固定するため。
 */
export function buildInspectionSelectionsOsusumeManualItemSave(params: {
  element: any;
  buhinList: any[];
  osusumeBuhinList: any[];
  uketsukeExtendsId: any;
  categoryId: any;
  doneStatus: number;
  deleteStatus: number;
  recommendManualType: number;
}): any {
  const element = params.element;
  return {
    sknUketsukeExtendsId: params.uketsukeExtendsId + "",
    seibiId: element.seibiId,
    seibiNm: element.sknRecommendInspecSeibiNm,
    kouchinZn: element.kouchinZn,
    buhinSelected:
      element.osusumeIsShow == 1 ? params.doneStatus : params.deleteStatus,
    sknInspectType: params.recommendManualType,
    sknRecommendInspectCategoryId:
      params.categoryId != null
        ? params.categoryId
        : element.sknRecommendInspectCategoryId,
    osusumeIsShow: element.osusumeIsShow,
    buhinList: params.buhinList,
    manualBuhinList: element.manualBuhinList,
    osusumeBuhinList: params.osusumeBuhinList,
    kouchinZk: element.kouchinZk ? element.kouchinZk : null,
    buhinEditTotalZk: element.buhinEditTotalZk,
    buhinEditTotalZn: element.buhinEditTotalZn
  };
}

/*
 * jizen おすすめ保存 payload 生成を inspectionSelections.vue から分離し、
 * 通常おすすめと手入力おすすめの分類、非表示 item 除外、送信形を固定するため。
 */
export function buildInspectionSelectionsOsusumeSavePayload(params: {
  items: any[];
  uketsukeExtendsId: any;
  categoryId: any;
  isSocket: number;
  doneStatus: number;
  deleteStatus: number;
  recommendManualType: number;
}): any {
  const subItems: any[] = [];
  const manualItems: any[] = [];
  const items = Array.isArray(params.items) ? params.items : [];
  items.forEach((element: any) => {
    const buhinList = buildInspectionSelectionsOsusumeBuhinSaveList(
      element.buhinList
    );
    const osusumeBuhinList =
      buildInspectionSelectionsOsusumeRecommendBuhinSaveList(
        element.osusumeBuhinList
      );
    if (
      (element.osusumeId != null ||
        element.sknRecommendInspecSeibiId != null) &&
      element.manualSeibiId == null
    ) {
      if (!(element.seibiId == null && element.osusumeIsShow == 0)) {
        subItems.push(
          buildInspectionSelectionsOsusumeSubItemSave({
            element,
            buhinList,
            osusumeBuhinList
          })
        );
      }
    } else {
      manualItems.push(
        buildInspectionSelectionsOsusumeManualItemSave({
          element,
          buhinList,
          osusumeBuhinList,
          uketsukeExtendsId: params.uketsukeExtendsId,
          categoryId: params.categoryId,
          doneStatus: params.doneStatus,
          deleteStatus: params.deleteStatus,
          recommendManualType: params.recommendManualType
        })
      );
    }
  });
  return {
    isSocket: params.isSocket,
    jizen: [
      {
        recommend: [
          {
            subItems,
            manualItems
          }
        ]
      }
    ]
  };
}

/*
 * 現在表示中のおすすめ保存 state を inspectionSelections.vue から分離し、
 * jizen の active category/sub category に保存先があるかと保存 item 整形を固定するため。
 */
export function buildInspectionSelectionsOsusumeCurrentSaveState(params: {
  currentData: any;
  data: any;
  activeCategory: number;
  activeSubCategory: number;
}): InspectionSelectionsOsusumeCurrentSaveState {
  const data = params.data || {};
  const recommend =
    data.jizen &&
    data.jizen[params.activeCategory] &&
    data.jizen[params.activeCategory].recommend &&
    data.jizen[params.activeCategory].recommend[params.activeSubCategory];
  if (!recommend) {
    return {
      shouldSave: false,
      items: []
    };
  }
  const items = Array.isArray(params.currentData) ? params.currentData : [];
  return {
    shouldSave: true,
    items: items.map((item: any) => {
      const saveItem = {
        ...item
      };
      delete saveItem.status;
      delete saveItem.showWork;
      delete saveItem.isSaving;
      return saveItem;
    })
  };
}

/*
 * 手入力おすすめ追加 item 生成を inspectionSelections.vue から分離し、
 * 入力値とカテゴリ ID から API 保存用 item を作る契約を固定するため。
 */
export function buildInspectionSelectionsManualRecommendItemSave(
  params: InspectionSelectionsManualRecommendItemInput
): any {
  return {
    sknUketsukeExtendsId: params.uketsukeExtendsId + "",
    seibiNm: params.seibiNm,
    kouchinZn: params.kouchinZn,
    kouchinZk: params.kouchinZk,
    buhinSelected: params.doneStatus,
    sknInspectType: params.recommendManualType,
    sknRecommendInspectCategoryId: params.recommendCategoryId,
    osusumeIsShow: 1,
    buhinList: [],
    manualBuhinList: [],
    osusumeBuhinList: [],
    sknInspectCategoryId: params.inspectCategoryId
  };
}

/*
 * 手入力おすすめ追加 payload を inspectionSelections.vue から分離し、
 * manualItems に追加 item を詰める送信形を固定するため。
 */
export function buildInspectionSelectionsManualRecommendSavePayload(
  manualItem: any
): any {
  return {
    isSocket: 1,
    recommend: [
      {
        subItems: [],
        manualItems: [manualItem]
      }
    ]
  };
}

/*
 * 手入力おすすめ保存後の画面 item 生成を inspectionSelections.vue から分離し、
 * レスポンス seibiId と入力値から currentData に追加する形を固定するため。
 */
export function buildInspectionSelectionsAddedManualRecommendItem(params: {
  uketsukeExtendsId: any;
  seibiId: any;
  seibiNm: string;
  kouchinZn: any;
  doneStatus: number;
  completedStatus: number;
  recommendManualType: number;
  rowNum: number;
  recommendCategoryId: any;
}): any {
  return {
    sknUketsukeExtendsId: params.uketsukeExtendsId,
    sknInspectType: params.recommendManualType,
    branchId: "0",
    inspectResult: 0,
    isNumber: 0,
    inspectValue: 0,
    seibiId: params.seibiId,
    sknInspectCommentId: 0,
    inspectValueList: [],
    inspectValueViewType: 0,
    koukanMeyasuTime: 0,
    sknRecommendInspecSeibiId: null,
    sknRecommendInspecSeibiNm: params.seibiNm,
    sknInspectSeibiDetailId: 0,
    isInspectDuplicate: 0,
    kingaku: params.kouchinZn,
    kouchinZn: params.kouchinZn,
    buhinSelected: params.doneStatus,
    buhinList: [],
    manualBuhinList: [],
    osusumeIsShow: 1,
    sknRecommendInspectCategoryId: params.recommendCategoryId,
    osusumeBuhinList: [],
    isDoTenken: 0,
    rowNum: params.rowNum,
    isSaving: false,
    status: params.completedStatus
  };
}

/*
 * 保存済み通常おすすめ item の key 抽出を inspectionSelections.vue から分離し、
 * subItems から osusumeId / sknRecommendInspecSeibiId / manualSeibiId を取り出す契約を固定するため。
 */
export function getInspectionSelectionsSavedSubItemKeys(recommend: any): any[] {
  const subItems =
    recommend && Array.isArray(recommend.subItems) ? recommend.subItems : [];
  return subItems.map((item: any) =>
    item.osusumeId
      ? item.osusumeId
      : item.sknRecommendInspecSeibiId
      ? item.sknRecommendInspecSeibiId
      : item.manualSeibiId
  );
}

/*
 * 保存済み手入力おすすめ item の key 抽出を inspectionSelections.vue から分離し、
 * manualItems から seibiId を取り出す契約を固定するため。
 */
export function getInspectionSelectionsSavedManualItemKeys(
  recommend: any
): any[] {
  const manualItems =
    recommend && Array.isArray(recommend.manualItems)
      ? recommend.manualItems
      : [];
  return manualItems.map((item: any) => item.seibiId);
}

/*
 * 保存済み item の isSaving 解除を inspectionSelections.vue から分離し、
 * 保存レスポンスの sub/manual key に一致する currentData だけを更新するため。
 */
export function clearInspectionSelectionsSavedItemSavingState(params: {
  currentData: any[];
  subItemKeys: any[];
  manualItemKeys: any[];
  pendingItems?: any[];
}): any[] {
  const subItemKeys = Array.isArray(params.subItemKeys)
    ? params.subItemKeys
    : [];
  const manualItemKeys = Array.isArray(params.manualItemKeys)
    ? params.manualItemKeys
    : [];
  return (Array.isArray(params.currentData) ? params.currentData : []).map(
    (item: any) => {
      const isSavedSubItem = subItemKeys.some(
        (key: any) =>
          (item.osusumeId && item.osusumeId === key) ||
          (item.sknRecommendInspecSeibiId &&
            item.sknRecommendInspecSeibiId === key) ||
          (item.manualSeibiId && item.manualSeibiId === key)
      );
      const isSavedManualItem = manualItemKeys.some(
        (key: any) => item.seibiId && item.seibiId === key
      );
      if (!isSavedSubItem && !isSavedManualItem) {
        return item;
      }
      return {
        ...item,
        isSaving: (params.pendingItems || []).some((pending: any) =>
          findInspectionSelectionsOsusumeSaveIndex([item], pending) > -1 ||
          (item.manualSeibiId && item.manualSeibiId === pending.manualSeibiId) ||
          (item.seibiId && item.seibiId === pending.seibiId)
        )
      };
    }
  );
}

/*
 * beforeDestroy の保存 state を inspectionSelections.vue から分離し、
 * tempListSave/tempWaitSave と timer の flush/clear 条件を固定するため。
 */
export function resolveInspectionSelectionsBeforeDestroySaveState(params: {
  timerSave: any;
  tempListSave: any;
  tempWaitSave: any;
  timerSaving: any;
}): InspectionSelectionsBeforeDestroySaveState {
  const hasTempListSave =
    Array.isArray(params.tempListSave) && params.tempListSave.length > 0;
  const hasTimerSave = !!params.timerSave;
  const hasTempWaitSave = !!params.tempWaitSave;
  const hasTimerSaving = !!params.timerSaving;
  return {
    shouldFlushTempListSave: hasTempListSave,
    shouldClearTimerSave: hasTimerSave || hasTempListSave,
    shouldFlushTempWaitSave: hasTempWaitSave && hasTimerSaving,
    shouldClearTimerSaving: hasTempWaitSave && hasTimerSaving
  };
}

/*
 * おすすめ保存レスポンス item の status 集計を inspectionSelections.vue から分離し、
 * item 正規化、sumStatus、件数、最大 rowNum を固定するため。
 */
export function buildInspectionSelectionsRecommendResponseItemsState(
  items: any,
  currentMaxRowNum: number
): InspectionSelectionsRecommendResponseItemsState {
  const source = Array.isArray(items) ? items : [];
  let maxRowNum = currentMaxRowNum;
  const normalizedItems = source.map((obj: any) => {
    if (obj.rowNum > maxRowNum) {
      maxRowNum = obj.rowNum;
    }
    return {
      ...obj,
      showWork: false
    };
  });
  return {
    items: normalizedItems,
    sumStatus: normalizedItems.reduce(
      (sum: number, item: any) => sum + (item.status ? item.status : 0),
      0
    ),
    nItem: normalizedItems.length,
    maxRowNum
  };
}

/*
 * 保存レスポンス item の同一判定を inspectionSelections.vue から分離し、
 * osusumeId / sknRecommendInspecSeibiId / seibiId による突合条件を固定するため。
 */
export function isInspectionSelectionsSameRecommendItem(
  source: any,
  target: any
): boolean {
  const sourceItem = source || {};
  const targetItem = target || {};
  return !!(
    (sourceItem.osusumeId && sourceItem.osusumeId == targetItem.osusumeId) ||
    (sourceItem.sknRecommendInspecSeibiId &&
      sourceItem.sknRecommendInspecSeibiId ==
        targetItem.sknRecommendInspecSeibiId) ||
    (sourceItem.seibiId && sourceItem.seibiId == targetItem.seibiId)
  );
}

/*
 * 保存済み通常おすすめ item の反映を inspectionSelections.vue から分離し、
 * currentData の同一 item を保存レスポンス item で置換する契約を固定するため。
 */
export function mergeInspectionSelectionsSavedSubItems(
  currentSubItems: any,
  savedSubItems: any
): any[] {
  const currentItems = Array.isArray(currentSubItems) ? currentSubItems : [];
  const savedItems = Array.isArray(savedSubItems) ? savedSubItems : [];
  return savedItems.reduce((items: any[], element: any) => {
    return items.map((item: any) =>
      isInspectionSelectionsSameRecommendItem(element, item)
        ? { ...element }
        : { ...item }
    );
  }, currentItems);
}

/*
 * 保存済み手入力おすすめ item の反映を inspectionSelections.vue から分離し、
 * deleteStatus item の除外と既存手入力 item の部品・金額 field 更新を固定するため。
 */
export function applyInspectionSelectionsSavedManualItems(
  currentSubItems: any,
  savedManualItems: any,
  deleteStatus: number
): any[] {
  const currentItems = Array.isArray(currentSubItems) ? currentSubItems : [];
  const manualItems = Array.isArray(savedManualItems) ? savedManualItems : [];
  return manualItems.reduce((items: any[], element: any) => {
    return items
      .filter((item: any) => {
        if (
          element.seibiId &&
          element.seibiId == item.seibiId &&
          element.buhinSelected == deleteStatus
        ) {
          return false;
        }
        return true;
      })
      .map((item: any) => {
        if (element.seibiId && element.seibiId == item.seibiId) {
          return {
            ...item,
            buhinList: element.buhinList,
            buhinSelected: element.buhinSelected,
            buhinShubetsuCd: element.buhinShubetsuCd,
            kouchinZk: element.kouchinZk,
            kouchinZn: element.kouchinZn,
            koukanMeyasuTime: element.koukanMeyasuTime,
            kousuu: element.kousuu,
            manualBuhinList: element.manualBuhinList,
            osusumeBuhinList: element.osusumeBuhinList,
            osusumeIsShow: element.osusumeIsShow
          };
        }
        return { ...item };
      });
  }, currentItems);
}

/*
 * 保存済みおすすめカテゴリ state 生成を inspectionSelections.vue から分離し、
 * レスポンスカテゴリの正規化、status 集計、最大 rowNum 更新を固定するため。
 */
export function buildInspectionSelectionsSavedRecommendCategoriesState(params: {
  recommendCategories: any;
  maxRowNum: number;
  normalizeItem?: (item: any) => any;
}): InspectionSelectionsSavedRecommendCategoriesState {
  const categories = Array.isArray(params.recommendCategories)
    ? params.recommendCategories
    : [];
  const normalizeItem =
    params.normalizeItem ||
    ((item: any): any => {
      return item;
    });
  let maxRowNum = params.maxRowNum;
  const categoryStatuses: InspectionSelectionsSavedRecommendCategoryStatus[] =
    [];
  const recommendCategories = categories.map((cate: any) => {
    const category = {
      ...cate
    };
    if (category.subItems) {
      const responseItemsState =
        buildInspectionSelectionsRecommendResponseItemsState(
          category.subItems.map((obj: any) => normalizeItem(obj)),
          maxRowNum
        );
      category.subItems = responseItemsState.items;
      maxRowNum = responseItemsState.maxRowNum;
      categoryStatuses.push({
        sumStatus: responseItemsState.sumStatus,
        nItem: responseItemsState.nItem,
        cate: category
      });
    }
    if (category.manualItems) {
      const responseItemsState =
        buildInspectionSelectionsRecommendResponseItemsState(
          category.manualItems.map((obj: any) => normalizeItem(obj)),
          maxRowNum
        );
      category.manualItems = responseItemsState.items;
      maxRowNum = responseItemsState.maxRowNum;
      categoryStatuses.push({
        sumStatus: responseItemsState.sumStatus,
        nItem: responseItemsState.nItem,
        cate: category
      });
    }
    return category;
  });
  return {
    recommendCategories,
    categoryStatuses,
    maxRowNum
  };
}

/*
 * 保存済みおすすめカテゴリの反映 state を inspectionSelections.vue から分離し、
 * activeRecommend に保存済み sub/manual items を merge する契約を固定するため。
 */
export function buildInspectionSelectionsSavedRecommendApplyState(params: {
  activeRecommend: any;
  savedRecommend: any;
  deleteStatus: number;
}): InspectionSelectionsSavedRecommendApplyState {
  const activeRecommend = params.activeRecommend;
  const savedRecommend = params.savedRecommend || {};
  if (!activeRecommend) {
    return {
      shouldUpdate: false,
      subItems: []
    };
  }
  let subItems = activeRecommend.subItems;
  if (savedRecommend.subItems && savedRecommend.subItems.length > 0) {
    subItems = mergeInspectionSelectionsSavedSubItems(
      subItems,
      savedRecommend.subItems
    );
  }
  if (savedRecommend.manualItems && savedRecommend.manualItems.length > 0) {
    subItems = applyInspectionSelectionsSavedManualItems(
      subItems,
      savedRecommend.manualItems,
      params.deleteStatus
    );
  }
  return {
    shouldUpdate: true,
    subItems
  };
}

/*
 * jizen おすすめの currentData 生成を inspectionSelections.vue から分離し、
 * 保存中 skip、金額 flag、表示 item 初期化の契約を固定するため。
 */
export function buildInspectionSelectionsOsusumeCurrentDataState(params: {
  data: any;
  activeCategory: number;
  activeSubCategory: number;
  isSaving: boolean;
}): InspectionSelectionsOsusumeCurrentDataState {
  if (params.isSaving) {
    return {
      shouldUpdate: false,
      kingakuFlg: false,
      loadData: false,
      currentData: []
    };
  }
  const recommend =
    params.data &&
    params.data.jizen &&
    params.data.jizen[params.activeCategory] &&
    params.data.jizen[params.activeCategory].recommend &&
    params.data.jizen[params.activeCategory].recommend[params.activeSubCategory];
  if (!recommend) {
    return {
      shouldUpdate: false,
      kingakuFlg: false,
      loadData: false,
      currentData: []
    };
  }
  const kingakuZn = recommend.kingakuZn ? recommend.kingakuZn : null;
  const kingakuZk = recommend.kingakuZk ? recommend.kingakuZk : null;
  const subItems = Array.isArray(recommend.subItems) ? recommend.subItems : [];
  return {
    shouldUpdate: true,
    kingakuFlg: !!((kingakuZn && kingakuZn > 0) || (kingakuZk && kingakuZk > 0)),
    loadData: true,
    currentData: subItems.map((item: any) => ({
      ...item,
      isSaving: false
    }))
  };
}

/*
 * 通常カテゴリの currentData 生成を inspectionSelections.vue から分離し、
 * activeCategory の通常/おすすめ判定と subItems 反映を固定するため。
 */
export function buildInspectionSelectionsCurrentDataState(params: {
  data: any;
  apiPath: string;
  activeCategory: number;
}): InspectionSelectionsCurrentDataState {
  const categories =
    params.data && Array.isArray(params.data[params.apiPath])
      ? params.data[params.apiPath]
      : [];
  const activeCategoryData = categories[params.activeCategory];
  if (!activeCategoryData) {
    return {
      shouldUpdate: false,
      isOsusume: false,
      loadData: false,
      currentData: [],
      activeCategoryData: null
    };
  }
  if (activeCategoryData.osusume) {
    return {
      shouldUpdate: true,
      isOsusume: true,
      loadData: false,
      currentData: [],
      activeCategoryData
    };
  }
  return {
    shouldUpdate: true,
    isOsusume: false,
    loadData: true,
    currentData: Array.isArray(activeCategoryData.subItems)
      ? Array.from(activeCategoryData.subItems)
      : [],
    activeCategoryData
  };
}

/*
 * active おすすめカテゴリ解決を inspectionSelections.vue から分離し、
 * data.jizen の activeCategory/activeSubCategory から recommend を取り出す契約を固定するため。
 */
export function resolveInspectionSelectionsActiveRecommend(params: {
  data: any;
  activeCategory: number;
  activeSubCategory: number;
}): any {
  const data = params.data || {};
  if (
    !data.jizen ||
    !data.jizen[params.activeCategory] ||
    !data.jizen[params.activeCategory].recommend
  ) {
    return null;
  }
  return data.jizen[params.activeCategory].recommend[params.activeSubCategory]
    ? data.jizen[params.activeCategory].recommend[params.activeSubCategory]
    : null;
}

/*
 * カテゴリ status 判定の入力生成を inspectionSelections.vue から分離し、
 * currentData の件数と status 合計を固定するため。
 */
export function buildInspectionSelectionsCategoryStatusInput(
  currentData: any
): InspectionSelectionsCategoryStatusInput {
  const items = Array.isArray(currentData) ? currentData : [];
  return {
    nItem: items.length,
    sumStatus: items.reduce(
      (sum: number, cur: any) => sum + (cur.status ? cur.status : 0),
      0
    )
  };
}

/*
 * 通常点検カテゴリ status state を inspectionSelections.vue から分離し、
 * inspectDescriptions の表示用 field 初期化と status 集計を固定するため。
 */
export function buildInspectionSelectionsNormalCategoryStatusState(
  subItems: any
): InspectionSelectionsNormalCategoryStatusState {
  const items = Array.isArray(subItems) ? subItems : [];
  let nItem = 0;
  let sumStatus = 0;
  const normalizedSubItems = items.map((item: any) => {
    const inspectDescriptions = Array.isArray(item.inspectDescriptions)
      ? item.inspectDescriptions
      : [];
    nItem += inspectDescriptions.length;
    return {
      ...item,
      inspectDescriptions: inspectDescriptions.map((inspect: any) => {
        if (inspect.status) {
          sumStatus += inspect.status;
        }
        return {
          ...inspect,
          showWork: false,
          showValue: false,
          isSaving: false
        };
      })
    };
  });
  return {
    subItems: normalizedSubItems,
    nItem,
    sumStatus
  };
}

/*
 * おすすめカテゴリ status state を inspectionSelections.vue から分離し、
 * osusumeIsShow=1 の item だけを対象に status を再計算するため。
 */
export function buildInspectionSelectionsRecommendCategoryStatusState(params: {
  subItems: any;
  doneStatus: number;
  noNeedStatus: number;
  completedStatus: number;
  incompleteStatus: number;
}): InspectionSelectionsRecommendCategoryStatusState {
  const items = Array.isArray(params.subItems) ? params.subItems : [];
  let nItem = 0;
  let sumStatus = 0;
  const subItems = items.map((item: any) => {
    if (item.osusumeIsShow != 1) {
      return item;
    }
    nItem += 1;
    if (
      item.buhinSelected == params.doneStatus ||
      item.buhinSelected == params.noNeedStatus
    ) {
      sumStatus += item.buhinSelected;
      return {
        ...item,
        status: params.completedStatus
      };
    }
    return {
      ...item,
      status: params.incompleteStatus
    };
  });
  return {
    subItems,
    nItem,
    sumStatus
  };
}

/*
 * カテゴリ status 判定を inspectionSelections.vue から分離し、
 * status 合計と item 数から none/completed/incomplete を決める契約を固定するため。
 */
export function resolveInspectionSelectionsCategoryStatus(params: {
  sumStatus: number;
  nItem: number;
  noneStatus: number;
  completedStatus: number;
  incompleteStatus: number;
}): number {
  if (params.sumStatus == 0) {
    return params.noneStatus;
  }
  if (params.sumStatus == params.nItem * params.completedStatus) {
    return params.completedStatus;
  }
  return params.incompleteStatus;
}

/*
 * おすすめ表示切替の分岐を inspectionSelections.vue から分離し、
 * 重複エラー、即保存、確認 dialog の action を固定するため。
 */
export function buildInspectionSelectionsOsusumeShowChangeState(
  item: any
): InspectionSelectionsOsusumeShowChangeState {
  if (item && item.isInspectDuplicate && item.osusumeIsShow) {
    return {
      shouldShowDuplicateError: true,
      shouldConfirm: false,
      shouldSave: false,
      itemState: {},
      activeInspect: item
    };
  }
  if (item && (item.buhinSelected == 0 || item.osusumeIsShow == 0)) {
    const osusumeIsShow = item.osusumeIsShow ? 0 : 1;
    return {
      shouldShowDuplicateError: false,
      shouldConfirm: false,
      shouldSave: true,
      itemState: {
        osusumeIsShow,
        ...(osusumeIsShow == 0 ? { inspectResult: 0 } : {}),
        osusumeBuhinList: null,
        buhinList: []
      },
      activeInspect: item
    };
  }
  return {
    shouldShowDuplicateError: false,
    shouldConfirm: true,
    shouldSave: false,
    itemState: {},
    activeInspect: item
  };
}

/*
 * おすすめ非表示確認後の state を inspectionSelections.vue から分離し、
 * 非表示化、部品削除要否、カテゴリ status 更新値を固定するため。
 */
export function buildInspectionSelectionsConfirmHideOsusumeState(params: {
  item: any;
  completedStatus: number;
  initialBuhinStatus: number;
}): InspectionSelectionsConfirmHideOsusumeState {
  const item = params.item || {};
  const shouldDeleteBuhin = item.isInspectDuplicate == 0;
  return {
    arrStatusValue: params.completedStatus,
    activeInspect: {},
    itemState: {
      osusumeIsShow: 0,
      ...(shouldDeleteBuhin
        ? { buhinSelected: params.initialBuhinStatus }
        : {})
    },
    shouldDeleteBuhin
  };
}

/*
 * 通常点検保存成功後の pending save 判定を inspectionSelections.vue から分離し、
 * 保存中に追加された tempWaitSave を次に保存する state を固定するため。
 */
export function resolveInspectionSelectionsPendingInspectSaveState(params: {
  isCallSaveWhenSaving: boolean;
  tempWaitSave: any;
}): InspectionSelectionsPendingInspectSaveState {
  const shouldCallPendingSave = !!(
    params.isCallSaveWhenSaving && params.tempWaitSave
  );
  return {
    shouldCallPendingSave,
    pendingItems: shouldCallPendingSave ? params.tempWaitSave : null,
    isCallSaveWhenSaving: false,
    tempWaitSave: shouldCallPendingSave ? null : params.tempWaitSave
  };
}

/*
 * 通常点検保存成功時の tempListSaving 判定を inspectionSelections.vue から分離し、
 * apiPath 不一致や未選択単体保存時の return 条件を固定するため。
 */
export function resolveInspectionSelectionsTempListSavingState(params: {
  apiPath: string;
  currentApiPath: string;
  tempListSaving: any;
}): InspectionSelectionsTempListSavingState {
  if (params.apiPath != params.currentApiPath) {
    return {
      shouldReturn: true,
      shouldClearTempListSaving: false
    };
  }
  const tempListSaving = Array.isArray(params.tempListSaving)
    ? params.tempListSaving
    : [];
  if (
    tempListSaving.length == 1 &&
    tempListSaving[0].workBuhinSelected == 0
  ) {
    return {
      shouldReturn: true,
      shouldClearTempListSaving: false
    };
  }
  return {
    shouldReturn: false,
    shouldClearTempListSaving: true
  };
}

/*
 * 通常点検保存 error state を inspectionSelections.vue から分離し、
 * 通知対象名、保存中リスト clear、再読み込み要否を固定するため。
 */
export function buildInspectionSelectionsInspectSaveErrorState(
  tempListSaving: any
): InspectionSelectionsInspectSaveErrorState {
  const tempItems = Array.isArray(tempListSaving) ? tempListSaving : [];
  return {
    notifyNames: tempItems.map(
      (inspect: any) => inspect.sknInspectDescriptionNm
    ),
    tempListSaving: [],
    shouldClearCurrentData: true,
    shouldInitPage: true
  };
}

/*
 * 複数通常点検保存 error state を inspectionSelections.vue から分離し、
 * カテゴリ名通知、保存キュー clear、再読み込み要否を固定するため。
 */
export function buildInspectionSelectionsMultipleInspectSaveErrorState(params: {
  data: any;
  apiPath: string;
}): InspectionSelectionsMultipleInspectSaveErrorState {
  const apiData = params.data && params.data[params.apiPath];
  const message =
    apiData &&
    apiData[0] &&
    apiData[0].subItems &&
    apiData[0].subItems[0]
      ? apiData[0].subItems[0].sknInspectCategoryNm
      : undefined;
  return {
    message,
    tempListSave: [],
    arrStatus: [],
    shouldInitPage: true
  };
}

/*
 * MD3 route flag 生成を inspectionSelections.vue から分離し、
 * inspectType から gensha/legal56/jizen の boolean を固定するため。
 */
export function buildInspectionSelectionsMd3RouteFlags(
  inspectType: number,
  inspectTypes: InspectionSelectionsInspectTypes
): InspectionSelectionsMd3RouteFlags {
  return {
    isGensha: inspectType == inspectTypes.GENSHA,
    isLegal56: inspectType == inspectTypes.LEGAL56,
    isJizen: inspectType == inspectTypes.JIZEN
  };
}

/*
 * タイヤ残溝の点検値 list 生成を inspectionSelections.vue から分離し、
 * 車両情報の前後左右値を branchId 付き配列へ変換する契約を固定するため。
 */
export function buildInspectionSelectionsTireValueList(
  carSelection: any
): any[] {
  const car = carSelection || {};
  return [
    {
      branchId: 1,
      inspectValue: car.fLeftTireNokorimizo
    },
    {
      branchId: 2,
      inspectValue: car.fRightTireNokorimizo
    },
    {
      branchId: 3,
      inspectValue: car.rLeftTireNokorimizo
    },
    {
      branchId: 4,
      inspectValue: car.rRightTireNokorimizo
    }
  ];
}

/*
 * 点検値保存 state を inspectionSelections.vue から分離し、
 * 既存 inspectValueList と新しい値が同じ場合は保存しない判定を固定するため。
 */
export function buildInspectionSelectionsInspectValueSaveState(params: {
  inspect: any;
  listVal: any[];
}): InspectionSelectionsInspectValueSaveState {
  const inspect = params.inspect || {};
  const listVal = Array.isArray(params.listVal) ? params.listVal : [];
  let shouldSave = true;
  if (inspect.inspectValueList) {
    const values = inspect.inspectValueList
      .map((e: any) => e.inspectValue)
      .join();
    const newValues = listVal.map((e: any) => e.inspectValue).join();
    if (values === newValues) {
      shouldSave = false;
    }
  }
  return {
    listVal,
    shouldSave
  };
}

/*
 * 地上最低高の自動反映 state を inspectionSelections.vue から分離し、
 * 車両情報の最低地上高を未入力点検結果へ反映する条件を固定するため。
 */
export function buildInspectionSelectionsSaiteiChijouKouState(params: {
  inspect: any;
  carSelection: any;
  groundClrViewType: number;
}): InspectionSelectionsInspectResultSaveState {
  const inspect = params.inspect || {};
  const car = params.carSelection || {};
  const shouldSave = !!(
    inspect.inspectValueViewType == params.groundClrViewType &&
    inspect.inspectResult == 0 &&
    car.sknSaiteiChijouKou
  );
  return {
    shouldSave,
    inspectResult: shouldSave ? car.sknSaiteiChijouKou : inspect.inspectResult
  };
}

export function buildInspectionSelectionsSyncObdState(params: {
  inspect: any;
  carSelection: any;
  syncObdViewType: number;
  circleValue: number;
  crossValue: number;
}): InspectionSelectionsInspectResultSaveState {
  const inspect = params.inspect || {};
  const car = params.carSelection || {};
  const shouldSave = !!(
    inspect.inspectValueViewType == params.syncObdViewType &&
    car.meterPanelAlert &&
    !inspect.inspectResult
  );
  return {
    shouldSave,
    inspectResult:
      shouldSave
        ? car.meterPanelAlert == 2
          ? params.crossValue
          : params.circleValue
        : inspect.inspectResult
  };
}

/*
 * サイドスリップ点検値 list 生成を inspectionSelections.vue から分離し、
 * sideSlipValue を branchId=1 の inspectValue として送る契約を固定するため。
 */
export function buildInspectionSelectionsSideSlipValueList(
  sideSlipValue: any
): any[] {
  return [
    {
      branchId: 1,
      inspectValue: sideSlipValue
    }
  ];
}

/*
 * サイドスリップ保存 state を inspectionSelections.vue から分離し、
 * 対象 viewType と既存値との差分から保存要否を決めるため。
 */
export function buildInspectionSelectionsSideSlipSaveState(params: {
  inspect: any;
  sideSlipValue: any;
  sideSlipViewType: number;
}): InspectionSelectionsInspectValueSaveState {
  const inspect = params.inspect || {};
  const listVal = buildInspectionSelectionsSideSlipValueList(
    params.sideSlipValue
  );
  const shouldSave = !!(
    inspect.inspectValueViewType == params.sideSlipViewType &&
    (!inspect.inspectValueList ||
      inspect.inspectValueList.length == 0 ||
      inspect.inspectValueList[0].inspectValue != params.sideSlipValue)
  );
  return {
    listVal,
    shouldSave
  };
}

/*
 * lazy load 対象カテゴリ判定を inspectionSelections.vue から分離し、
 * subItems 未取得カテゴリと jizen おすすめ除外条件を固定するため。
 */
export function shouldLoadInspectionSelectionsCategoryDetail(
  category: any,
  apiPath: string
): boolean {
  if (!category || !category.subItems || category.subItems.length != 0) {
    return false;
  }
  if (apiPath == "jizen") {
    return category.osusume == false;
  }
  return true;
}

/*
 * lazy load 対象カテゴリ ID 抽出を inspectionSelections.vue から分離し、
 * load 対象カテゴリの sknInspectCategoryId 配列を作る契約を固定するため。
 */
export function getInspectionSelectionsLazyLoadCategoryIds(
  categories: any,
  apiPath: string
): any[] {
  const items = Array.isArray(categories) ? categories : [];
  return items
    .filter((category: any) =>
      shouldLoadInspectionSelectionsCategoryDetail(category, apiPath)
    )
    .map((category: any) => category.sknInspectCategoryId);
}

/*
 * カテゴリ position から ID を解決する処理を inspectionSelections.vue から分離し、
 * categories[pos].sknInspectCategoryId を route 保存用に取り出す契約を固定するため。
 */
export function resolveInspectionSelectionsCategoryIdByPosition(
  categories: any,
  pos: any
): any {
  const items = Array.isArray(categories) ? categories : [];
  const category = items[Number(pos)];
  return category && category.sknInspectCategoryId
    ? category.sknInspectCategoryId
    : undefined;
}

/*
 * 最後に選択したカテゴリ情報の値取得を inspectionSelections.vue から分離し、
 * 保存情報がない場合の fallback を固定するため。
 */
export function resolveInspectionSelectionsLastSelectedValue(
  hasLastSelectedCategoryId: boolean,
  lastCategoryInfo: any,
  key: string,
  fallback: any = -1
): any {
  if (
    hasLastSelectedCategoryId &&
    lastCategoryInfo &&
    lastCategoryInfo[key] != null
  ) {
    return lastCategoryInfo[key];
  }
  return fallback;
}

/*
 * route info 生成を inspectionSelections.vue から分離し、
 * apiPath、カテゴリ ID、pos/subPos の保存形式を固定するため。
 */
export function buildInspectionSelectionsRouteInfo(params: {
  categories: any;
  apiPath: string;
  inspectType: number;
  jizenType: number;
  pos: number;
  lastSelectedSubPos: number;
}): any {
  return {
    apiPath: params.apiPath,
    sknInspectCategoryId: resolveInspectionSelectionsCategoryIdByPosition(
      params.categories,
      params.pos
    ),
    pos: params.pos,
    subPos:
      params.inspectType == params.jizenType ? params.lastSelectedSubPos : 0
  };
}

/*
 * カテゴリ変更 state を inspectionSelections.vue から分離し、
 * activeCategory 更新、currentData clear、routeInfo 生成を固定するため。
 */
export function buildInspectionSelectionsCategoryChangeState(params: {
  activeCategory: number;
  nextCategory: number;
  categories: any;
  apiPath: string;
  inspectType: number;
  jizenType: number;
  lastSelectedSubPos: number;
}): InspectionSelectionsCategoryChangeState {
  const shouldChange = params.activeCategory != params.nextCategory;
  return {
    shouldChange,
    activeCategory: shouldChange
      ? params.nextCategory
      : params.activeCategory,
    activeSubCategory: 0,
    currentData: [],
    routeInfo: shouldChange
      ? buildInspectionSelectionsRouteInfo({
          categories: params.categories,
          apiPath: params.apiPath,
          inspectType: params.inspectType,
          jizenType: params.jizenType,
          pos: params.nextCategory,
          lastSelectedSubPos: params.lastSelectedSubPos
        })
      : null
  };
}

/*
 * jizen sub category 変更 state を inspectionSelections.vue から分離し、
 * activeSubCategory 更新、currentData clear、routeInfo 生成を固定するため。
 */
export function buildInspectionSelectionsSubCategoryChangeState(params: {
  activeSubCategory: number;
  nextSubCategory: number;
  categories: any;
  apiPath: string;
  activeCategory: number;
}): InspectionSelectionsSubCategoryChangeState {
  const shouldChange = params.activeSubCategory != params.nextSubCategory;
  return {
    shouldChange,
    activeSubCategory: shouldChange
      ? params.nextSubCategory
      : params.activeSubCategory,
    currentData: [],
    routeInfo: shouldChange
      ? {
          apiPath: params.apiPath,
          sknInspectCategoryId:
            resolveInspectionSelectionsCategoryIdByPosition(
              params.categories,
              params.nextSubCategory
            ),
          pos: params.activeCategory,
          subPos: params.nextSubCategory
        }
      : null
  };
}

/*
 * カテゴリ復元 state を inspectionSelections.vue から分離し、
 * 最終選択カテゴリ/subカテゴリ復元と未完了位置スクロール要否を固定するため。
 */
export function resolveInspectionSelectionsRestoreState(params: {
  hasLastSelectedCategoryId: boolean;
  lastCategoryInfo: any;
  length: number;
  inspectType: number;
  jizenType: number;
}): any {
  const pos = resolveInspectionSelectionsLastSelectedValue(
    params.hasLastSelectedCategoryId,
    params.lastCategoryInfo,
    "pos",
    -1
  );
  const subPos = resolveInspectionSelectionsLastSelectedValue(
    params.hasLastSelectedCategoryId,
    params.lastCategoryInfo,
    "subPos",
    -1
  );
  return {
    shouldRestoreCategory: pos > -1 && params.length > pos,
    pos: Number(pos),
    shouldRestoreSubCategory:
      params.inspectType == params.jizenType && subPos > 0,
    subPos,
    shouldScrollToFirstIncomplete: !params.hasLastSelectedCategoryId
  };
}

/*
 * 通常点検 WorkAndBuhin open state を inspectionSelections.vue から分離し、
 * showWork=true、activeInspect、activeSubCateIndex 更新を固定するため。
 */
export function buildInspectionSelectionsWorkOpenState(
  item: any,
  subCateIndex: number
): InspectionSelectionsWorkOpenState {
  return {
    itemState: {
      showWork: true
    },
    activeInspect: item,
    activeSubCateIndex: subCateIndex
  };
}

/*
 * WorkAndBuhin confirm 時の重複判定対象 list 生成を inspectionSelections.vue から分離し、
 * 同一点検除外とタイヤ項目の別 sub category 連結を固定するため。
 */
export function buildInspectionSelectionsConfirmInspectList(params: {
  currentData: any[];
  activeSubCateIndex: number;
  inspectItem: any;
  tireViewType: number;
}): any[] {
  const currentData = Array.isArray(params.currentData)
    ? params.currentData
    : [];
  const activeSubCategory = currentData[params.activeSubCateIndex];
  let listInspect =
    activeSubCategory && Array.isArray(activeSubCategory.inspectDescriptions)
      ? activeSubCategory.inspectDescriptions.filter(
          (inspect: any) =>
            inspect.sknInspectDescriptionId !=
            params.inspectItem.sknInspectDescriptionId
        )
      : [];
  if (params.inspectItem.inspectValueViewType == params.tireViewType) {
    let subCatIndex = 0;
    if (params.activeSubCateIndex == 0) {
      subCatIndex = 1;
    }
    const tireSubCategory = currentData[subCatIndex];
    if (tireSubCategory && Array.isArray(tireSubCategory.inspectDescriptions)) {
      listInspect = listInspect.concat(tireSubCategory.inspectDescriptions);
    }
  }
  return listInspect;
}

/*
 * jizen おすすめ自動設定要否を inspectionSelections.vue から分離し、
 * 手入力でない jizen 点検だけを対象にする条件を固定するため。
 */
export function shouldInspectionSelectionsAutoSetJizenRecommend(params: {
  notManual: boolean;
  inspectType: number;
  jizenType: number;
}): boolean {
  return !!params.notManual && params.inspectType == params.jizenType;
}

/*
 * WorkAndBuhin confirm state を inspectionSelections.vue から分離し、
 * 重複判定 list と jizen おすすめ/重複整備の自動設定要否を固定するため。
 */
export function buildInspectionSelectionsConfirmBuhinState(params: {
  currentData: any;
  activeSubCateIndex: number;
  inspectItem: any;
  tireViewType: number;
  notManual: boolean;
  inspectType: number;
  jizenType: number;
}): InspectionSelectionsConfirmBuhinState {
  return {
    listInspect: buildInspectionSelectionsConfirmInspectList({
      currentData: params.currentData,
      activeSubCateIndex: params.activeSubCateIndex,
      inspectItem: params.inspectItem,
      tireViewType: params.tireViewType
    }),
    shouldAutoSetJizenRecommend:
      shouldInspectionSelectionsAutoSetJizenRecommend({
        notManual: params.notManual,
        inspectType: params.inspectType,
        jizenType: params.jizenType
      }),
    shouldAutoSetDuplicateSeibi: !!params.notManual
  };
}

/*
 * 通常点検 WorkAndBuhin close state を inspectionSelections.vue から分離し、
 * close event から保存要否、socket 要否、保存対象を決めるため。
 */
export function buildInspectionSelectionsCloseState(
  event: any,
  activeInspect: any
): InspectionSelectionsCloseState {
  const shouldSave = !!(event && (event.isResetSeibi || event.isChange));
  return {
    shouldSave,
    isSocket: shouldSave && !!event.isSocket,
    activeInspect: shouldSave ? activeInspect : null
  };
}

/*
 * おすすめ WorkAndBuhin open/close toggle を inspectionSelections.vue から分離し、
 * showWork と activeInspect の切替 state を固定するため。
 */
export function buildInspectionSelectionsOsusumeWorkToggleState(
  item: any
): InspectionSelectionsOsusumeWorkToggleState {
  const showWork = !(item && item.showWork);
  return {
    itemState: {
      showWork
    },
    activeInspect: showWork ? item : {}
  };
}

/*
 * おすすめ WorkAndBuhin confirm state を inspectionSelections.vue から分離し、
 * isDoTenken 更新と保存実行要否を固定するため。
 */
export function buildInspectionSelectionsOsusumeConfirmState(
  item: any
): InspectionSelectionsOsusumeConfirmState {
  return {
    itemState: {
      isDoTenken: item && item.osusumeIsShow == 1 ? 1 : 0
    },
    item,
    shouldChangeStatus: true,
    shouldSave: true
  };
}

/*
 * 通常点検の選択ボタン文言を inspectionSelections.vue から分離し、
 * workBuhinSelected から「選択」/「選択済」を決める契約を固定するため。
 */
export function getInspectionSelectionsWorkButtonLabel(inspect: any): string {
  return inspect && inspect.workBuhinSelected == 0 ? "選択" : "選択済";
}

/*
 * おすすめの選択ボタン文言を inspectionSelections.vue から分離し、
 * buhinSelected から「選択」/「選択済」を決める契約を固定するため。
 */
export function getInspectionSelectionsOsusumeWorkButtonLabel(
  inspect: any
): string {
  return inspect && inspect.buhinSelected == 0 ? "選択" : "選択済";
}

/*
 * 選択/値ボタン class 判定を inspectionSelections.vue から分離し、
 * 選択済、未完了、通常表示の分岐を固定するため。
 */
export function getInspectionSelectionsWorkValueClass(params: {
  selectedValue: any;
  isIncomplete: boolean;
}): string {
  if (params.selectedValue != null && params.selectedValue > 0) {
    return "green";
  }
  if (params.isIncomplete) {
    return "red";
  }
  return "normal bold";
}

/*
 * おすすめ表示ボタン class 判定を inspectionSelections.vue から分離し、
 * osusumeIsShow から表示状態の class を決めるため。
 */
export function getInspectionSelectionsRecommendShowClass(inspect: any): string {
  return inspect && inspect.osusumeIsShow ? "green" : "normal bold";
}

/*
 * おすすめ WorkAndBuhin 操作可否を inspectionSelections.vue から分離し、
 * osusumeIsShow による disabled 判定を固定するため。
 */
export function isInspectionSelectionsOsusumeDisabled(item: any): boolean {
  return !(item && item.osusumeIsShow);
}

/*
 * おすすめ WorkAndBuhin close state を inspectionSelections.vue から分離し、
 * close event から保存要否、socket 要否、isSaving 更新を固定するため。
 */
export function buildInspectionSelectionsOsusumeCloseState(
  event: any,
  activeInspect: any
): InspectionSelectionsOsusumeCloseState {
  const shouldSave = !!(event && (event.isResetSeibi || event.isChange));
  return {
    shouldSave,
    isSocket: shouldSave && !!event.isSocket,
    activeInspect: shouldSave ? activeInspect : null,
    itemState: shouldSave
      ? {
          isSaving: true
        }
      : {}
  };
}
